export enum TicketStageType {
  Edit = 'edit',
  Review = 'review',
  Sign = 'sign',
  Finalize = 'finalize',
  Ticket = 'ticket',
}
